export interface PaginationCatalogProps {
  currentPage: number;
  totalPages: number;
  showPagesNearby?: number;
  simbol?: number | string;
}

export const getPaginationList = ({
  currentPage,
  totalPages,
  showPagesNearby = 2,
  simbol = '...',
}: PaginationCatalogProps): (number | string)[] => {
  const LEFT = currentPage - showPagesNearby;
  const RIGHT = currentPage + showPagesNearby;
  const range = [];

  const startRange = [1, 2, 3];
  const endRange = [totalPages - 2, totalPages - 1, totalPages];

  if (totalPages <= 6) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  switch (currentPage) {
    case 1:
    case totalPages:
      range.push(...startRange, simbol, ...endRange);
      break;
    default:
      if (LEFT >= 2) {
        range.push(1);
      }
      if (LEFT > 2) {
        range.push(simbol);
      }
      if (currentPage >= LEFT && currentPage < RIGHT) {
        range.push(LEFT, currentPage, RIGHT);
      }
      if (RIGHT < totalPages - 1) {
        range.push(simbol);
      }
      if (RIGHT < totalPages) {
        range.push(totalPages);
      }
      break;
  }
  return range;
};
